module.exports = __webpack_public_path__ + "static/media/index_26.8cc4f565.jpg";